export const userConstants = [
  'v_client_id', /* 1 */
  'v_user_id', /* 2 */
  'v_billing_status', /* 3 */
  'v_profile_custom_age', /* 4 */
  'v_plan',
  'v_mso', /* 5 */
  'v_language', /* 6 */
  'v_admin_profile', /* 7 */
  'v_profile_id', /* 8 */
  'v_app_name', /* 9 */
  'v_profile_unrated_content', /* 10 */
  'v_account_status',
  'v_login_type', /* 11 */
  'v_betting_enable', /* 12 */
  'v_isocode',
];
